<!-- Modal Header -->
<div class="modal-header bg-primary text-white rounded-top d-flex align-items-center justify-content-between">
  <h5 class="mb-0">{{ item?.label }}</h5>
  <button type="button" class="close-button text-white border-0 bg-transparent fs-4" aria-label="Close"
    (click)="close()">
    ×
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body d-flex flex-column" style="max-height: 450px; overflow-y: auto;">
  <!-- Tabs -->
  <ul class="nav nav-tabs mt-2">
    <li class="nav-item">
      <a class="nav-link" [class.active]="isActive('info')" (click)="setActiveTab('info')">Information</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="isActive('sops')" (click)="setActiveTab('sops')">SOPS</a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content mt-3">
    <!-- Information Tab -->
    @if (isActive('info')) {
      <div>
        <h6 class="fw-bold">Address:</h6>
        <p>{{ item?.attributes?.address || 'N/A' }}</p>
        @if (item?.attributes?.extraInformation) {
          <div>
            <p>{{ item.attributes.extraInformation }}</p>
          </div>
        }
        <div class="mt-3">
          <h6>
            {{ item?.label }} POCs [{{ item?.attributes?.poc?.length || 0 }}]:
          </h6>
          <table class="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th>Label</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              @for (poc of item.attributes.poc; track poc) {
                <tr>
                  <td>{{ poc.pocLabel }}</td>
                  <td>{{ poc.name }}</td>
                  <td>{{ poc.email }}</td>
                  <td>{{ poc.phone }}</td>
                </tr>
              }
            </tbody>
          </table>
          <!-- <p *ngIf="!item?.attributes?.poc?.length" class="text-muted">
          No POCs available.
        </p> -->
      </div>
    </div>
  }

  <!-- SOPS Tab -->
  @if (isActive('sops')) {
    <div>
      @if (item?.attributes?.sops?.length) {
        <ul>
          @for (sop of item.attributes.sops; track sop) {
            <li>{{ sop }}</li>
          }
        </ul>
      } @else {
        <p>No SOPS available for this facility.</p>
      }
    </div>
  }
</div>
</div>